import React from 'react';
import classNames from 'classnames';

interface LoadingProps {
  size?: 'sm' | 'md' | 'lg';
  color?: 'primary' | 'white' | 'gray' | 'purple';
  fullScreen?: boolean;
  text?: string;
  className?: string;
}

const Loading: React.FC<LoadingProps> = ({
  size = 'md',
  color = 'primary',
  fullScreen = false,
  text,
  className,
}) => {
  const sizeStyles = {
    sm: 'w-6 h-6',
    md: 'w-10 h-10',
    lg: 'w-16 h-16',
  };

  const colorStyles = {
    primary: 'border-blue-primary-500',
    white: 'border-white',
    gray: 'border-gray-500',
    purple: 'border-purple-400',
  };

  const spinner = (
    <div className={classNames('flex flex-col items-center gap-3', className)}>
      <div
        className={classNames(
          'rounded-full border-4 border-t-transparent animate-spin',
          sizeStyles[size],
          colorStyles[color]
        )}
      />
      {text && (
        <p
          className={classNames('text-sm font-medium', {
            'text-blue-primary-500': color === 'primary',
            'text-white': color === 'white',
            'text-gray-600': color === 'gray',
            'text-purple-400': color === 'purple',
          })}
        >
          {text}
        </p>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-90 z-50">
        {spinner}
      </div>
    );
  }

  return spinner;
};

export default Loading;
